import { OPERATIONS } from '../../../constants/bulkEdit';
import { ATTRIBUTE } from '../../../constants/attributes';
import { EMPTY } from '../../../constants';

import actions from '../../../actions';

export function getPreviewActions({ channel, preview }) {
  function reducePreviewAttributes(result, value, attribute) {
    switch (attribute) {
      case ATTRIBUTE.DESCRIPTION: {
        switch (value.get('operation')) {
          case OPERATIONS[channel].DESCRIPTION.AI_GENERATED: {
            if (value.get('generate')) {
              return result.push(actions.bulkEdit.aiPreviewGenerate({ attribute }));
            }

            return result;
          }

          default: {
            return result;
          }
        }
      }

      case ATTRIBUTE.META_DESCRIPTION: {
        switch (value.get('operation')) {
          case OPERATIONS[channel].META_DESCRIPTION.AI_GENERATED: {
            if (value.get('generate')) {
              return result.push(actions.bulkEdit.aiPreviewGenerate({ attribute }));
            }

            return result;
          }

          default: {
            return result;
          }
        }
      }

      case ATTRIBUTE.PAGE_TITLE: {
        switch (value.get('operation')) {
          case OPERATIONS[channel].PAGE_TITLE.AI_GENERATED: {
            if (value.get('generate')) {
              return result.push(actions.bulkEdit.aiPreviewGenerate({ attribute }));
            }

            return result;
          }

          default: {
            return result;
          }
        }
      }

      case ATTRIBUTE.PHOTOS: {
        switch (value.get('operation')) {
          case OPERATIONS[channel].PHOTOS.ALT_TEXT_AI_GENERATED: {
            if (value.get('generate')) {
              return result.push(actions.bulkEdit.aiPreviewGenerate({ attribute }));
            }

            return result;
          }

          default: {
            return result;
          }
        }
      }

      case ATTRIBUTE.TITLE: {
        switch (value.get('operation')) {
          case OPERATIONS[channel].TITLE.AI_GENERATED: {
            if (value.get('generate')) {
              return result.push(actions.bulkEdit.aiPreviewGenerate({ attribute }));
            }

            return result;
          }

          default: {
            return result;
          }
        }
      }

      case ATTRIBUTE.TAGS: {
        switch (value.get('operation')) {
          case OPERATIONS[channel].TAGS.AI_GENERATED: {
            if (value.get('generate')) {
              return result.push(actions.bulkEdit.aiPreviewGenerate({ attribute }));
            }

            return result;
          }

          default: {
            return result;
          }
        }
      }

      default: {
        return result;
      }
    }
  }

  return preview.reduce(reducePreviewAttributes, EMPTY.LIST);
}
